'use client';

import { useQuery, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from './queryKeys';
import { useApi } from './useApi';

export function useAuthStatus() {
    const { auth } = useApi();
    const queryClient = useQueryClient();

    const invalidateAuthStatus = () => {
        queryClient.invalidateQueries({
            queryKey: queryKeys.authStatus,
        });
    };

    const query = useQuery({
        queryKey: queryKeys.authStatus,
        queryFn: auth.getAuthStatus,
        refetchOnWindowFocus: true,
        refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
        retry: false, // Don't retry on auth failures
    });

    return {
        ...query,
        invalidateAuthStatus,
    };
}
